import { render, staticRenderFns } from "./subAttributeModal.vue?vue&type=template&id=40eb33ec&scoped=true"
import script from "./subAttributeModal.vue?vue&type=script&lang=js"
export * from "./subAttributeModal.vue?vue&type=script&lang=js"
import style0 from "./subAttributeModal.vue?vue&type=style&index=0&id=40eb33ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40eb33ec",
  null
  
)

export default component.exports